import { render, staticRenderFns } from "./CompanySecretsCard.vue?vue&type=template&id=35904586&"
import script from "./CompanySecretsCard.vue?vue&type=script&lang=js&"
export * from "./CompanySecretsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports